/**
 * ============================================================================
 * useCompleteRequalMutation — Phase 6e frontend (Equipment & Validation).
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: POST /api/v1/equipment/requalifications/{id}/complete — close
 *          an IN_PROGRESS requalification. The server requires a signed
 *          REQUAL qualification document id; we collect it here.
 * ============================================================================
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiFetch, newIdempotencyKey } from '../../api/client';
import type { RequalScheduleRow } from './useRequalificationScheduleQuery';

export interface CompleteRequalInput {
  requalificationId: string;
  qualification_document_id: string;
  signature_bundle_id: string;
}

export function useCompleteRequalMutation(): UseMutationResult<
  RequalScheduleRow,
  Error,
  CompleteRequalInput
> {
  return useMutation<RequalScheduleRow, Error, CompleteRequalInput>({
    mutationFn: ({ requalificationId, ...body }) =>
      apiFetch<RequalScheduleRow>(
        `/api/v1/equipment/requalifications/${encodeURIComponent(requalificationId)}/complete`,
        {
          method: 'POST',
          body,
          idempotencyKey: newIdempotencyKey(),
        },
      ),
  });
}
